<template>
  <div class="container">
    <el-upload
      class="upload-demo"
      action="/v2/validate/Upload"
      :headers="myHeaders"
      :on-change="handleChange"
      :on-remove="handleRemove"
      :on-success="handleAvatarSuccess"
      multiple
      :limit="9"
    >
      <el-button size="small" type="primary" class="upfile">点击上传</el-button>
      <div slot="tip" class="el-upload__tip"></div>
    </el-upload>
    <el-button size="small" type="primary" @click="preview()">在线预览</el-button>
    <p id="volume">体积:{{volume}}</p>
    <p id="area">表面积:{{area}}</p>
    <div id="root" style="width: 800px; height: 600px;"></div>
    <el-table
      :data="tableData"
      style="width: 100%;margin-bottom: 20px;"
      row-key="id"
      border
      default-expand-all
      lazy
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
    >
      <el-table-column prop="name" label="材料" sortable width="180"></el-table-column>
      <el-table-column prop="color" label="颜色" sortable width="100"></el-table-column>
      <el-table-column prop="tolerance" label="公差"></el-table-column>
      <el-table-column prop="time" label="预计交货时间">72小时</el-table-column>
      <el-table-column prop="num" label="文件数量">{{drawing.length}}</el-table-column>
      <el-table-column prop="address" label="增值服务"></el-table-column>
      <el-table-column prop="address" label="总价格"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div>已选择项<el-button size="small">点击下单</el-button></div>
  </div>
</template>

    
<script>
import Vue from "vue";
import { ACCESS_TOKEN } from "@/store/mutation-types";
const config = {
  progress: {
    onRendered: (volume, area, box) => {
      // 此处的 root 是 HTML 中 API 容器的 id
      document.getElementById("volume").innerHTML = "体积:" + volume + "mm³"
      document.getElementById("area").innerHTML = "表面积:" + area + "mm²"
    },
    onProgress: progress => {
      console.log(progress);
    }
  }
};
let apiLoaded = false;
//服务器
const api = new EverAPI(
  "d59c3dfe4285",
  "4657717ca0671803994220842a795cc9",
  config
);
//本地
// const api = new EverAPI(
//   "6103ec4a2189",
//   "cc239b39cd09383aba9b1310db8cf334",
//   config
// );
export default {
  name: "Everxyz",
  data() {
    return {
      publicPath: process.env.BASE_URL,
      myHeaders: { "Access-Token": Vue.ls.get(ACCESS_TOKEN) },
      drawing: [],
      tableData: [
        
      ],
      volume:0,
      area:0
    };
  },
  methods: {
    handleAvatarSuccess(response) {
      this.drawing.push("https://yungc.2mould.com/upload/" + response.data);
    },
    handleChange(file, fileList) {
        for(let i = 0 ; i < this.tableData.length ; i ++){
          this.tableData[i].children = []
          
          for(let j = 0 ; j < fileList.length ; j ++ ){
            const child = {
              name : fileList[j].name,
              num : 0
            }
            this.tableData[i].children.push(child)
          }
          
        }
        
      },
    handleRemove(file, fileList) {
      let name = "https://yungc.2mould.com/upload/" + file.response.data;
      for (let i = 0; i < this.drawing.length; i++) {
        if (this.drawing[i] == name) {
          this.drawing.splice(i, 1);
        }
      }
      this.preview();
    },
    preview() {
      const files = [];
      if (this.drawing.length > 0) {
        for (let i = 0; i < this.drawing.length; i++) {
          const stls = {
            filename:
              i +
              this.drawing[i].slice(
                this.drawing[i].lastIndexOf("."),
                this.drawing[i].length
              ),
            url: this.drawing[i]
          };
          files.push(stls);
        }
        console.log(files);
        //api.render("root", files);
        //apiLoaded = true;
      }
      if (apiLoaded) {
        console.log(files);
        api.render("root", files);
      } else {
        this.$message.error("加载中,请稍后");
      }
    },
  },
  created() {
    window.addEventListener("oneverapiloaded", event => {
      apiLoaded = true;
      api.render("root", []);
    });
    this.$http
      .get("/v2/GetMoulds")
      .then(res => {
        this.tableData = res.data.moulds_3d
      })
      .catch(error => {});
  },
  mounted() {},
};
</script>

<style scoped>
</style>